import { render, staticRenderFns } from "./ImportFaturamentoList.vue?vue&type=template&id=c4e8c46c"
import script from "./ImportFaturamentoList.vue?vue&type=script&lang=ts"
export * from "./ImportFaturamentoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports